import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom"
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import './css/calendar.css'
import moment from 'moment';
import { LoadingModal } from './component/modal/modal';
import { change_Current_Location, changeHeaderTitle } from '../store';
import { changeNum } from './common/function';
import { ChevronRight, ArrowDownToLine } from 'lucide-react';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function SettlementCalendar() {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const today = new Date();
    const [date, setDate] = useState(today);
    const [activeStartDate, setActiveStartDate] = useState(new Date());
    const [loading, setLoading] = useState(true)
    const [modal, setModal] = useState(false)
    const [listData, setListData] = useState([])
    const [clickData, setClickData] = useState([])

    const handleDateChange = (newDate) => {
        setDate(newDate);
    };

    const handleTodayClick = () => {
        const today = new Date();
        setActiveStartDate(today);
        setDate(today);
    };

    useEffect(() => {
        dispatch(change_Current_Location("정산달력"))
        dispatch(changeHeaderTitle({
            mainTitle: "정산관리",
            subTitle: "정산달력"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const [value, setValue] = useState(new Date().getFullYear());
    const [holidays, setHolidays] = useState([]);

    useEffect(() => {
        // 공휴일 데이터를 가져오는 함수
        const fetchHolidays = async () => {
            const year = value;
            try {
                const response = await axios.get(
                    'https://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/getHoliDeInfo',
                    {
                        params: {
                            solYear: year, // 연도를 지정
                            ServiceKey: process.env.REACT_APP_HOLIDAY_APIKEY, // 발급받은 서비스 키
                            numOfRows: 100, // 한 번에 가져올 데이터 수
                            _type: 'json', // JSON 형식으로 응답 받기
                        },
                    }
                );

                const holidayList = response.data.response.body.items.item.map(item => ({
                    date: item.locdate.toString(), // 날짜를 처리 (YYYYMMDD 형식)
                    name: item.dateName, // 공휴일 이름
                }));

                setHolidays(holidayList); // 공휴일 데이터를 상태에 저장
            } catch (error) {
                console.error('Error fetching holidays:', error);
            }
        };

        fetchHolidays();
    }, [value]);

    const isHoliday = (date) => {
        return holidays.some(holiday => holiday.date === formatDate(date));
    };

    const getHolidayName = (date) => {
        const holiday = holidays.find(holiday => holiday.date === formatDate(date));
        return holiday ? holiday.name : null;
    };

    // 날짜 포맷을 YYYYMMDD 형식으로 변환하는 함수
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (`0${date.getMonth() + 1}`).slice(-2); // 월을 2자리로
        const day = (`0${date.getDate()}`).slice(-2); // 일을 2자리로
        return `${year}${month}${day}`;
    };


    useEffect(() => {
        ListData()
    }, [activeStartDate])

    const ListData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/settlement/daily/calander", {
            withCredentials: true,
            params: {
                month: `${activeStartDate.getFullYear()}-${(`0${activeStartDate.getMonth() + 1}`).slice(-2)}`,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const UpdateData = async (item) => {
        console.log(item.date);
        if (window.confirm("정산하시겠습니까?") === true) {
            await axios.post(process.env.REACT_APP_API + "/settlement/update-check", {
                date: item.date,
                check: 1
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                console.log(tmp)
                if (tmp?.code < 2000) {
                    window.location.reload();
                }
                else if (tmp?.code === 9999) {
                    navigate('/')
                }
            }).catch(error => {
                console.error(error);
            });
        }
    }

    const [screenSize, setScreenSize] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            if (window.innerWidth <= 850) {
                setScreenSize('small');
            } else if (window.innerWidth <= 1200) {
                setScreenSize('medium');
            } else {
                setScreenSize('large');
            }
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const changeNum = (num) => {
        if (typeof num !== 'number' || isNaN(num)) {
            return '0';
        }

        if (screenSize === 'small') {
            const kValue = num / 1000;
            if (kValue >= 1000) {
                return `${(kValue / 1000).toFixed(1).replace(/\.0$/, '')}m`;
            }
            const formattedKValue = kValue.toFixed(1).replace(/\.0$/, '');
            return formattedKValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + 'k';
        } else {
            return num.toLocaleString();
        }
    };

    return (
        <div className="content calendar" id="contents">
            {loading ? <LoadingModal /> : ""}
            {modal ? <DetailInfo setModal={setModal} UpdateData={UpdateData} clickData={clickData} /> : ""}
            <div className="intro-y box intro-padding">
                <Calendar
                    value={date}
                    onChange={handleDateChange}
                    formatDay={(locale, date) => moment(date).format('D')}
                    formatYear={(locale, date) => moment(date).format('YYYY')}
                    formatMonthYear={(locale, date) => moment(date).format('YYYY. MM')}
                    calendarType="gregory"
                    showNeighboringMonth={true}
                    next2Label={null}
                    prev2Label={null}
                    minDetail="year"

                    // 오늘 날짜로 돌아오는 기능을 위해 필요한 옵션 설정
                    activeStartDate={activeStartDate === null ? undefined : activeStartDate}
                    onActiveStartDateChange={({ activeStartDate }) => {
                        setValue(activeStartDate.getFullYear())
                        setActiveStartDate(activeStartDate)
                    }
                    }

                    // 오늘 날짜에 '오늘' 텍스트 삽입하고 출석한 날짜에 점 표시를 위한 설정
                    tileContent={({ date, view }) => {
                        let html = [];
                        if (view === 'month' && isHoliday(date)) {
                            html.push(<div className='StyledEX-hoilday'>
                                <div className='StyledEX-holiday'>
                                    <div>{screenSize !== 'small' && getHolidayName(date)}</div>
                                </div>
                            </div>);
                        }
                        if (view === "month") {
                            for (let i = 0; i < listData.length; i++) {
                                let tmp = listData[i]
                                if (tmp.settlement_date === moment(date).format("YYYY-MM-DD")) {
                                    html.push(
                                        <div className='StyledEX' onClick={() => { setClickData(tmp); setModal(true) }}>
                                            <div className='StyledEX-holiday StyledEX-3'>
                                                {screenSize === 'large' && <div>매출</div>}
                                                <div>{changeNum(Number(tmp.total_amt))}{screenSize !== 'small' && '원'}</div>
                                            </div>
                                            <div className={`StyledEX-holiday ${tmp.check === 0 ? "StyledEX-1" : "StyledEX-2"}`}>
                                                {screenSize === 'large' && <div>정산</div>}
                                                <div>{changeNum(Math.floor(Number(tmp.total_settlement_amt)))}{screenSize !== 'small' && '원'}</div>
                                            </div>
                                        </div>
                                    );
                                }
                            }
                        }
                        return <>{html}</>;
                    }}
                />

                {/* 오늘 버튼 추가 */}

                <ul className="calendar-category-wrap">
                    <li className="calendar-category">
                        <span className="dot" style={{ background: "#064e3b" }}></span>
                        <p>매출</p>
                    </li>
                    <li className="calendar-category">
                        <span className="dot" style={{ background: "#1c658c" }}></span>
                        <p>정산완료</p>
                    </li>
                    <li className="calendar-category">
                        <span className="dot" style={{ background: "#e59e2f" }}></span>
                        <p>정산예정</p>
                    </li>
                    <div className='StyledDate' onClick={handleTodayClick}>Today</div>
                </ul>
            </div>
        </div>
    )
}

function DetailInfo({ setModal, UpdateData, clickData }) {

    const excelDepositData = (exData) => {
        let arr = []
        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]

                arr.push({
                    "은행": t.bank_code,
                    "계좌번호": t.accnt_no,
                    "금액": changeNum(Number(t.total_settlement_amt)),
                    "지급사": "페이베이스",
                    "가맹점": t.co_nm,
                })
            }
        }
        Excel(arr)
    }

    return (
        <div id="modal" className="modal" tabindex="-1" >
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium text-base mr-auto modal_title_sty">상세내역</h2>
                        <button className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" aria-expanded="false" data-tw-toggle="dropdown" onClick={() => setModal(false)}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="plus" className="lucide lucide-plus w-4 h-4" data-lucide="plus">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <form id="modal-form">
                        <div className="modal-body" style={{ padding: "0.75rem 0" }}>
                            <div className="detail-form">
                                <table className="tbl-grid">
                                    <tbody>
                                        <tr className="border-btm">
                                            <th>정산일</th>
                                            <td data-id="SETTLEMENT_DATE">{clickData.settlement_date}</td>
                                        </tr>
                                        <tr>
                                            <th>승인건수</th>
                                            <td><money data-id="CONFIRM_CNT">{changeNum(Number(clickData?.transaction_cnt ?? 0))}</money><span>건</span></td>
                                        </tr>
                                        <tr>
                                            <th>승인금액</th>
                                            <td><money data-id="CONFIRM_AMT">{changeNum(Number(clickData?.total_amt ?? 0))}</money><span>원</span></td>
                                        </tr>
                                        <tr>
                                            <th>취소건수</th>
                                            <td><money data-id="CANCEL_CNT">{changeNum(Number(clickData?.sugi_cancel_count ?? 0))}</money><span>건</span></td>
                                        </tr>
                                        <tr>
                                            <th>취소금액</th>
                                            <td><money data-id="CANCEL_AMT">{changeNum(Number(clickData?.sugi_cancel_amount ?? 0))}</money><span>원</span></td>
                                        </tr>
                                        <tr className="border-btm">
                                            <th>합계</th>
                                            <td><money data-id="TOTAL_AMT">{changeNum(Number(clickData?.sugi_bill_amount ?? 0) - Number(clickData?.sugi_cancel_amount ?? 0))}</money><span>원</span></td>
                                        </tr>
                                        <tr>
                                            <th>지급금액</th>
                                            <td><money data-id="SETTLEMENT_AMT">{changeNum(Number(clickData?.total_settlement_amt ?? 0))}</money><span>원</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </form>
                    <div className="modal-footer">
                        {/* {
                            clickData.check === 1
                                ?
                                <button type="button" className="btn btn-primary w-20 modal_btn" id="settlement_btn">정산완료</button>
                                :
                                <button type="button" className="btn btn-primary w-20 modal_btn" id="settlement_btn" onClick={() => UpdateData(clickData)}>정산</button>
                        } */}
                        <button type="button" className="btn btn-primary w-20 modal_btn" id="settlement_btn" onClick={() => excelDepositData(clickData)}><ArrowDownToLine size={18} />입금엑셀</button>
                        <button type="button" className="btn btn-primary w-20 modal_btn" id="confirm_btn" onClick={() => setModal(false)}>확인</button>
                    </div>
                </div>
            </div>
        </div>
    )
}


const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `입금엑셀`;

    // 헤더 정의
    const header = ['입금은행', '입금계좌', '입금인성명', '입금액', '출금통장표시', '입금통장표시'];
    
    // 헤더와 데이터를 결합
    const rows = [
        header,  // 첫 번째 행에 헤더 추가
        ...excelData.map((data) => [
            data.은행,
            data.계좌번호,
            data.name,
            data.금액,
            data.가맹점,
            data.지급사,
        ])
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(rows);

    // 스타일 적용을 위한 설정
    if (!worksheet['!rows']) worksheet['!rows'] = [];
    if (!worksheet['!cols']) worksheet['!cols'] = [];

    // 전체 범위 가져오기
    const range = XLSX.utils.decode_range(worksheet['!ref']);

    // 모든 셀에 스타일 적용
    for (let row = range.s.r; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
            if (!worksheet[cellRef]) {
                worksheet[cellRef] = { v: '', t: 's' };
            }
            
            // 기본 스타일 (테두리)
            if (!worksheet[cellRef].s) worksheet[cellRef].s = {};
            worksheet[cellRef].s = {
                border: {
                    top: { style: 'thin', color: { rgb: '000000' } },
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                    left: { style: 'thin', color: { rgb: '000000' } },
                    right: { style: 'thin', color: { rgb: '000000' } }
                }
            };

            // 헤더 행 스타일
            if (row === 0) {
                worksheet[cellRef].s = {
                    ...worksheet[cellRef].s,
                    fill: { patternType: 'solid', fgColor: { rgb: 'DAE3F3' } },
                    font: { bold: true },
                    alignment: { horizontal: 'center', vertical: 'center' }
                };
            }
            // A, B, C, E, F열 가운데 정렬
            else if ([0, 1, 2, 4, 5].includes(col)) {
                worksheet[cellRef].s = {
                    ...worksheet[cellRef].s,
                    alignment: { horizontal: 'center', vertical: 'center' }
                };
            }
        }
    }

    // 열 너비 설정
    worksheet['!cols'] = [
        { wpx: 150 },
        { wpx: 150 },
        { wpx: 150 },
        { wpx: 150 },
        { wpx: 150 },
        { wpx: 150 }
    ];

    const wb = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array', cellStyles: true });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default SettlementCalendar;